import type { FC } from "react";
import styles from "./StepSection.module.css";

interface StepSectionProps {
  children?: React.ReactNode;
}

export const StepSection: FC<StepSectionProps> = ({ children }) => {
  return <section className={styles.stepSection}>{children}</section>;
};
